addBoardToOrgTemplate = require 'views/templates/popover_add_board_to_org'
Auth = require 'db/auth'
BoardSelectOrganizationView = require 'views/board-menu/board-select-organization-view'
CreateOrgView = require 'views/organization/create-org-view'
PopOver = require 'views/lib/pop-over'
templates = require 'views/internal/templates'
track = require 'debug/track'
Util = require 'lib/util'
getExperiment = require 'lib/experiments/simple-test'

module.exports = class BoardAddToOrganizationView extends BoardSelectOrganizationView

  viewTitleKey: 'add to a team'

  events: Util.extendEvents
    'click .js-new-org': 'newOrg'

  render: ->
    data = @model.toJSON { org: true }
    orgs = if @model.owned() then Auth.me().organizationList.models else []
    data.orgs = (org.toJSON() for org in orgs)
    data.hasOrgs = data.orgs.length != 0

    if data.idOrganization
      for org in data.orgs
        if org.id == data.idOrganization
          org.select = true

    data.isPrivate = @model.isPrivate()
    data.allowsSelfJoin = @model.allowsSelfJoin()

    @$el.html(addBoardToOrgTemplate(data))

    @updateOrgOptions()
    @

  newOrg: (e) ->
    track("Board Header", "Add to a Team menu", "New Org")
    Util.stop(e)

    createOpts = { boardToAddToOrg: @model }
    trackingOpts = { category: 'board', method: 'by clicking create team in change team menu' }

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, trackingOpts })



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-add-to-organization-view.coffee